import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {TabbedItem} from 'devextreme-react/form';


export default class FormTabbedItem extends Component {
    render() {
        return <TabbedItem
            {...omit(['loading_state', 'setProps', 'children'], this.props)}
        >
            {this.props.children}
        </TabbedItem>
    }
}

FormTabbedItem.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * Specifies the number of columns spanned by the item
     */
    colSpan: PropTypes.number,
    /**
     * Specifies a CSS class to be applied to the form item
     */
    cssClass: PropTypes.string,
    /**
     * Specifies the item's type. Set it to "simple" to create a simple item
     */
    itemType: PropTypes.oneOf(['empty', 'group', 'simple', 'tabbed', 'button']),
    /**
     * Specifies a name that identifies the form item
     */
    name: PropTypes.string,
    /**
     * Holds a configuration object for the TabPanel UI component used to display the current form item
     */
    tabPanelOptions: PropTypes.object,
    /**
     * An array of tab configuration objects
     */
    tabs: PropTypes.arrayOf(PropTypes.object),
    /**
     * Specifies whether or not the current form item is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the sequence number of the item in a form, group or tab
     */
    visibleIndex: PropTypes.number,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

FormTabbedItem.defaultProps = {
    // colSpan: undefined,
    // cssClass: undefined,
    itemType: 'simple',
    // name: undefined,
    // tabPanelOptions: undefined,
    // tabs: undefined,
    visible: true,
    // visibleIndex: undefined
};
